"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

require("./Table.scss");

var _excluded = ["fit", "isFluid", "isResponsive", "className", "hasWhiteBackground", "hasZebraStripes", "hasBorder", "noColumnBorder", "hasRowBorder", "theme", "hasHighlightOnHover", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var propTypes = {
  /** Change the density of the table layout */
  fit: (0, _propTypes.oneOf)(['tight', 'loose']),

  /** Custom class names*/
  className: _propTypes.string,

  /** Add white background color to the table */
  hasWhiteBackground: _propTypes.bool,

  /** Add background color to every other row of the table */
  hasZebraStripes: _propTypes.bool,

  /** Add border to the outer edge of the table */
  hasBorder: _propTypes.bool,

  /** Remove border from the columns */
  noColumnBorder: _propTypes.bool,

  /** Add border to the rows */
  hasRowBorder: _propTypes.bool,

  /** Adds a background color to the row when it is hovered */
  hasHighlightOnHover: _propTypes.bool,

  /** Makes the table 100% wide. */
  isFluid: _propTypes.bool,

  /** Add a wrapper around the table with overflow-x to make it more useful on small devices/spaces */
  isResponsive: _propTypes.bool,
  theme: (0, _propTypes.oneOf)(['light', 'dark']),
  children: _propTypes.node
};
/** A basic visual presentation of a standard table. This component is merely a helper that creates a table tag with proper class names. */

var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.tableRef = /*#__PURE__*/_react.default.createRef();
    _this.tableWrapperRef = /*#__PURE__*/_react.default.createRef();
    _this.state = {
      tableWidth: null,
      tableWrapperWidth: null,
      scrollEnd: false,
      scrollStart: true
    };
    _this.updateDimensions = _this.updateDimensions.bind(_assertThisInitialized(_this));
    _this.handleHorizontalScroll = _this.handleHorizontalScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isResponsive) {
        this.setState({
          tableWidth: this.tableRef.current.clientWidth,
          tableWrapperWidth: this.tableWrapperRef.current.clientWidth
        });
        window.addEventListener('resize', this.updateDimensions);
        this.tableWrapperRef.current.addEventListener('scroll', this.handleHorizontalScroll);
      }
    }
  }, {
    key: "handleHorizontalScroll",
    value: function handleHorizontalScroll(event) {
      if (this.tableRef) {
        var scrollLeft = event.target.scrollLeft;
        var _this$state = this.state,
            tableWidth = _this$state.tableWidth,
            tableWrapperWidth = _this$state.tableWrapperWidth;

        if (scrollLeft <= 0) {
          this.setState({
            scrollStart: true
          });
        } else {
          this.setState({
            scrollStart: false
          });
        }

        if (tableWidth - scrollLeft <= tableWrapperWidth) {
          this.setState({
            scrollEnd: true
          });
        } else {
          this.setState({
            scrollEnd: false
          });
        }
      }
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      this.setState({
        tableWidth: this.tableRef.current.clientWidth,
        tableWrapperWidth: this.tableWrapperRef.current.clientWidth
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.isResponsive) {
        window.removeEventListener('resize', this.updateDimensions);
        this.tableWrapperRef.current.removeEventListener('scroll', this.handleHorizontalScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fit = _this$props.fit,
          isFluid = _this$props.isFluid,
          isResponsive = _this$props.isResponsive,
          className = _this$props.className,
          hasWhiteBackground = _this$props.hasWhiteBackground,
          hasZebraStripes = _this$props.hasZebraStripes,
          hasBorder = _this$props.hasBorder,
          noColumnBorder = _this$props.noColumnBorder,
          hasRowBorder = _this$props.hasRowBorder,
          theme = _this$props.theme,
          hasHighlightOnHover = _this$props.hasHighlightOnHover,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var componentClassNames = (0, _classnames.default)('rds-table', {
        'rds-table--fit-loose': fit === 'loose',
        'rds-table--fit-tight': fit === 'tight',
        'rds-table--fluid': isFluid,
        'rds-table--has-zebra-stripes': hasZebraStripes,
        'rds-table--has-border': hasBorder,
        'rds-table--no-border-column': noColumnBorder,
        'rds-table--has-border-row': hasRowBorder,
        'rds-table--light': theme === 'light',
        'rds-table--dark': theme === 'dark',
        'rds-table--highlight-on-hover': hasHighlightOnHover,
        'rds-table--has-white-background': hasWhiteBackground
      }, className);
      var responsiveClassNames = (0, _classnames.default)('rds-table-responsive', {
        'rds-table-responsive-shadows': this.state.tableWidth > this.state.tableWrapperWidth,
        'rds-table-responsive-shadows--remove-right': this.state.scrollEnd,
        'rds-table-responsive-shadows--remove-left': this.state.scrollStart
      });
      if (isResponsive) return /*#__PURE__*/_react.default.createElement("div", {
        className: responsiveClassNames
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rds-table-responsive-wrapper",
        ref: this.tableWrapperRef
      }, /*#__PURE__*/_react.default.createElement("table", _extends({
        className: componentClassNames
      }, rest, {
        ref: this.tableRef
      }), children)));
      return /*#__PURE__*/_react.default.createElement("table", _extends({
        className: componentClassNames
      }, rest, {
        ref: this.tableRef
      }), children);
    }
  }]);

  return Table;
}(_react.Component);

Table.propTypes = propTypes;
var _default = Table;
exports.default = _default;